module.exports = __webpack_public_path__ + "static/img/dd-customer-01.f1faf55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-customer-01.jpg
// module id = VmBa
// module chunks = 1